<template>
	<div class="sort-container">
		Sort by
		<toggle name="sort" :options="sortOptions" selected="recommended" v-model="sortOrder"></toggle>
	</div>
</template>

<script>
import Toggle from './Toggle';

export default {
	data: function () {
		return {
			sortOptions: {
				recommended: 'Recommended',
				price: 'Price',
			},
		}
	},
	computed: {
		sortOrder: {
			set: function (value) {
				this.$store.dispatch('setSort', value);
			},
			get: function () {
				return this.$store.getters.sort;
			}
		},
	},

	components: {
		Toggle,
	}
}
</script>

<style lang="scss">
.sort-container {
	text-align: right;
}

h3 {
	display: inline-block;
	margin: 2px;
}

.toggle {
	display: inline;
}

.toggle label {
	display: inline-block;
	padding: 4px;
	margin: 2px;
}

.toggle .active {
	background: #28354b;
	color: white;
}
</style>
